var React = require('react');

function FullHeart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.66667 0C11.692 0 13.3333 1.66667 13.3333 4C13.3333 8.66667 8.33333 11.3333 6.66667 12.3333C5 11.3333 0 8.66667 0 4C0 1.66667 1.66667 0 3.66667 0C4.90667 0 6 0.666667 6.66667 1.33333C7.33333 0.666667 8.42667 0 9.66667 0Z","fill":"#6B7580"}));
}

FullHeart.defaultProps = {"width":"14","height":"13","viewBox":"0 0 14 13","fill":"none"};

module.exports = FullHeart;

FullHeart.default = FullHeart;
